var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTelegramWhiteBg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#telegram-white-bg_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1.5,
  d: "M12.005.75C18.22.75 23.26 5.789 23.26 12.005S18.22 23.26 12.005 23.26.75 18.22.75 12.005 5.789.75 12.005.75Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#26A4E3",
  fillRule: "evenodd",
  d: "M5.428 11.875a798 798 0 0 1 6.997-3.019c3.328-1.39 4.028-1.63 4.478-1.64.1 0 .32.02.47.14.12.1.15.23.17.33s.04.31.02.47c-.18 1.9-.96 6.508-1.36 8.627-.17.9-.5 1.2-.82 1.23-.7.06-1.229-.46-1.899-.9-1.06-.69-1.649-1.12-2.678-1.8-1.19-.78-.42-1.21.26-1.909.18-.18 3.248-2.979 3.308-3.228.01-.03.01-.15-.06-.21s-.17-.04-.25-.02c-.11.02-1.79 1.14-5.058 3.348-.48.33-.91.49-1.3.48-.43-.01-1.249-.24-1.868-.44-.75-.24-1.35-.37-1.3-.79.03-.22.33-.44.89-.67",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "telegram-white-bg_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgTelegramWhiteBg;